
import {map} from 'rxjs/operators';
import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {KeyValue} from '../../shared/key-value';
import {Router} from '@angular/router';

import {AuthorizationService} from '../../shared/authorization.service';

declare function init_input_check(): void;

@Component({
  selector: 'forgot-password',
  templateUrl: 'forgot-password.component.html'
})
export class ForgotPasswordComponent {
  email: string;
  public erroremailMsg = ''
  constructor(private router: Router,private _tokenService: AngularTokenService, private authService: AuthorizationService) {
  }
  EmailSent() {
      this.router.navigate(['/forgot-password-submit']);
  }

  ErrorEmail(error) {
    this.erroremailMsg = "Enter valid email registered for this program."
  }

  ngOnInit() {
    setTimeout(function(){
      init_input_check();
    }, 1000);
  }

  submit_forgot_password(){
    this._tokenService.resetPassword({
      login: this.email
    }).subscribe(
    data => {
      this.authService.post(KeyValue.api_after_password_recovery, {params:{ user_email: this.email}}).pipe(map(res => res)).subscribe(
        res =>{
          localStorage.setItem('current_email',JSON.stringify(this.email));
          this.EmailSent()
        },
        error => this.router.navigate([KeyValue.signinPath])
        );
    },
      error => {
        this.ErrorEmail(error);
        // this.EmailSent()
      }
    );
  }

  ForgotPassword(): void {
    //event.preventDefault();
    this.erroremailMsg = '';
    if (this.email != '' && this.email != undefined){
      this.submit_forgot_password();
    }
  }
}
